import React from "react";
import CardClass from "../../../CardClass";
import EmptyState from "../../../EmptyState";
import Table from "../../../Table";

export default class CardAdminQueueColumns extends CardClass {
    /**
     * Render the content of the card.
     */
    renderContent() {
        const rows = [];
        let i = 0;

        if (
            this.props.queue &&
            this.props.queue.view &&
            this.props.queue.view.columns
        ) {
            this.props.queue.view.columns.forEach((column) => {
                rows.push({
                    id: i++,
                    key: column
                });
            });
        }

        if (rows.length > 0) {
            return (
                <Table
                    columns={[
                        { key: "key", name: "Key", type: "string" },
                    ]}
                    rows={rows}
                />
            );
        }

        return (
            <EmptyState
                line1="Not Configured"
                line2="This queue has no columns set"
            />
        );
    }

    /**
     * @returns {string} The title of the card.
     */
    getTitle() {
        return "Columns";
    }
}